import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  GetProductCategorySlice,
  GetSubCategoryProductSlice,
} from "../../../redux/features/ProductCategorySlice";
import {
  CreateProductCatalogueSlice,
  EditProductSlice,
  GetCustomizeProductListSlice,
  GetProductOnIdBasisSlice,
} from "../../../redux/features/ProductCatalogueSlice";
import ReactMultiSelectCheckboxes from "react-multiselect-checkboxes";
import { GetCityManagementSlice } from "../../../redux/features/CityManagementSlice";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { FaCloudDownloadAlt } from "react-icons/fa";
import { TbEditCircle } from "react-icons/tb";
import { onImageHandler } from "../../../components/UploadImageOnBucket";
import { IoMdClose } from "react-icons/io";
import { toast } from "react-toastify";
import ButtonSpinner from "../../../common/Loader/ButtonSpinner";
import Editor from "../../../common/Editor/Editor";
const ProductCatalogueEdit = () => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const [selectedForProduct, setSelectedForProduct] = useState({});
  const [CustomizeProduct, setCustomizeProduct] = useState([]);
  const [dataForSendToApi, setDataForSendToApi] = useState({
    productDetails: {
      productcategory: "",
      productsubcategory: "",
      productname: "",
      producttitledescription: "",
      estimatedecorativetime: "",
    },
    priceDetails: {
      price: "",
      gstslab: "",
      discountedPrice:""
    },
    productdescription: {
      inclusion: [],
      aboutexperience: "",
      need: "",
      cancellation: "",
    },
    productcustomizeDetails: {
      description: "",
    },
    availableCities: {
      cityName: "",
    },
  });

  const [productImages, setProductImages] = useState([]);
  const [SelectedOptions, setSelectedOptions] = useState();
  const [AllCities, setAllCities] = useState();
  const [CityManagement, setCityManagement] = useState([]);
  const [check, setCheck] = useState([]);
  const [TempForNonReasonableRending, setTempForNonReasonableRending] =
    useState([]);

  const [customObj, setCustomeObj] = useState([
    // {id:Math.round(Math.random()*10000), ProductName: "", ProductPrice: "", ProductImage: "" },
  ]);

  const [data, setData] = useState({
    categoryList: "",
    subcategoryList: "",
  });

  const { loading } = useSelector((state) => state.ProductCatalogue);

  const navigate = useNavigate();

  useEffect(() => {
    dispatch(GetProductOnIdBasisSlice(id)).then((res) => {
      const dummyData = res.payload.data;
      // console.log("dummyData:",dummyData);
      setTempForNonReasonableRending(dummyData);
      setDataForSendToApi({
        productDetails: {
          productcategory: dummyData?.productDetails?.productcategory,
          productsubcategory: dummyData?.productDetails?.productsubcategory,
          productname: dummyData?.productDetails?.productname,
          producttitledescription:
            dummyData?.productDetails?.producttitledescription,
          estimatedecorativetime: String(
            dummyData?.productDetails?.estimatedecorativetime
          ),
        },
        priceDetails: {
          price: dummyData?.priceDetails?.price,
          gstslab: dummyData?.priceDetails?.gstslab,
          discountedPrice: dummyData?.priceDetails?.discountedPrice,
        },
        productdescription: {
          inclusion: dummyData?.productdescription?.inclusion,
          aboutexperience: dummyData?.productdescription?.aboutexperience,
          need: dummyData?.productdescription?.need,
          cancellation: dummyData?.productdescription?.cancellation,
        },
        productcustomizeDetails: {
          description: dummyData?.productcustomizeDetails?.description,
        },
        availableCities: {
          cityName: dummyData?.availableCities,
        },
      });

      setCheck(dummyData?.productdescription?.inclusion);

      setSelectedOptions(
        dummyData?.availableCities[0]
          ?.split(", ")
          ?.map((city) => ({ lable: city, value: city }))
      );

      const AllProductImages = dummyData.productimages?.reduce(
        (obj, item, index) => ({
          ...obj,
          [Math.round(Math.random() * 100000)]: item,
        }),
        {}
      );

      console.log("AllProduct", dummyData.productcustomizeDetails);

      setProductImages(AllProductImages);

      setCustomeObj(dummyData.productcustomizeDetails);
    });
  }, [id]);

  useEffect(() => {
    dispatch(GetProductCategorySlice()).then((res) => {
      // finding id for preselected category field, for hiting sub category api;
      const category = res?.payload?.data.category;
      const preselectedCategory =
        dataForSendToApi?.productDetails?.productcategory;
      const filterCategoryData = category?.find(
        (item) =>
          item.categoryName.toLowerCase().trim() ===
          preselectedCategory.toLowerCase().trim()
      );
      setSelectedForProduct((prev) => ({
        ...prev,
        ["productcategory"]: filterCategoryData?._id,
      }));

      setData((prev) => ({
        ...prev,
        categoryList: category,
      }));
    });

    dispatch(GetCityManagementSlice()).then((res) => {
      setCityManagement(res?.payload?.data);
    });
  }, [TempForNonReasonableRending]);

  useEffect(() => {
    // console.log("selectedForProduct:", selectedForProduct);
    if (selectedForProduct["productcategory"]) {
      dispatch(
        GetSubCategoryProductSlice(selectedForProduct["productcategory"])
      ).then((res) => {
        const dummyData = res?.payload?.data?.subcategory;
        setData((prev) => ({ ...prev, subcategoryList: dummyData }));
      });
    }
  }, [selectedForProduct]);

  const handleChange = (e, parentKey) => {
    const { name, value } = e.target;
    console.log("name:", name, parentKey, "value:", value);
    setDataForSendToApi((prev) => ({
      ...prev,
      [parentKey]: {
        ...prev[parentKey],
        [name]: value,
      },
    }));
  };

  const handleImage = async (e) => {
    const { name, files } = e.target;
    // console.log("files:",files);
    if (!files || files.length === 0) return;

    if (name === "productImage") {
      const len = [Math.round(Math.random() * 100000)];
      try {
        const data = await onImageHandler(e);
        setProductImages((prev) => ({
          ...prev,
          [len]: data[1]?.location,
        }));
      } catch (error) {
        toast.error("Something went worng with AWS bucket");
      }
    }
  };

  function handleRemove(selectedItem) {
    const filterData = Object.entries(productImages).filter(
      ([key, value], index) => key !== selectedItem
    );

    setProductImages(Object.fromEntries(filterData));
  }

  const options = [
    "Welcome Drinks",
    "Opulent romantic bohemian garden canopy with luxurious cushions, elegant mats, vibrant flowers, candles, and intimate low dining tables",
    "Sumptuous 4 course meal with delectable soups, 2 starters, 2 mains and 2 desserts",
    "Cuisine: North Indian",
    "Location: Senate garden or private terrace",
    "Butler Service",
    "Ambience Music",
    "Alcoholic Beverages",
    "Pickup and drop",
    "Mist fans/ heaters",
  ];

  useEffect(() => {
    // console.log(CityManagement?.cities)
    if (Array.isArray(CityManagement?.cities)) {
      const dataForCity = CityManagement?.cities?.map((data) => ({
        label: data.cityName,
        value: data.cityName,
      }));
      setAllCities(dataForCity);
    }
  }, [CityManagement]);

  const handleMultiSelectChange = (selected, parentKey) => {
    setDataForSendToApi((prev) => ({
      ...prev,
      [parentKey]: {
        cityName: selected.map((option) => option.value).join(", "),
      },
    }));
    setSelectedOptions(selected);
  };

  const handleSubmit = () => {
    const formData = new FormData();
    // formData.append("productid", 1);\
    console.log("11:", dataForSendToApi);
    // console.log(
    //   "productDetails:",Object.entries(dataForSendToApi.productDetails).map(([key,item])=>item?.length).every((item)=> item > 0),
    //   "priceDetails:",Object.entries(dataForSendToApi.priceDetails).map(([key,item])=>item?.length).every((item)=> item > 0),
    //   "productdescription:",dataForSendToApi.productdescription,Object.entries(dataForSendToApi.productdescription).map(([key,item])=>item?.length).every((item)=> item > 0),
    //   "cityName:",dataForSendToApi.availableCities.cityName?.length > 0,
    //   "productImages:",productImages?.length > 0,
    //   "customObj",customObj?.map((item)=>item.length).every((item)=> item > 0))

    const Productdetail = dataForSendToApi.productDetails;

    if (!Productdetail?.productname?.length) {
      toast.error("Please fill product name!");
      return;
    }

    if (!Productdetail?.productcategory?.length) {
      toast.error("Please select category!");
      return;
    }

    if (!Productdetail?.productsubcategory?.length) {
      toast.error("Please select sub category!");
      return;
    }

    if (!dataForSendToApi.availableCities.cityName?.length > 0) {
      toast.error("Please Please select City!");
      return;
    }

    if (!Productdetail?.estimatedecorativetime?.length) {
      toast.error("Please fill estimated Decoration time!");
      return;
    }

    console.log(dataForSendToApi.priceDetails?.price);

    if (!String(dataForSendToApi.priceDetails?.price)?.length) {
      toast.error("please Fill Price details");
      return false;
    }

    if (!dataForSendToApi.priceDetails?.gstslab?.length) {
      toast.error("please Fill GST % details");
      return false;
    }

    const ProductDesc = dataForSendToApi.productdescription;

    if (!ProductDesc?.aboutexperience.length) {
      toast.error("Please Please fill about experience details!");
      return;
    }
    if (!ProductDesc?.cancellation?.length) {
      toast.error("Please Please fill cancellation details!");
      return;
    }

    if (!ProductDesc?.inclusion?.length) {
      toast.error("Please Please fill inclusion details!");
      return;
    }

    console.log(productImages);

    if (Object.entries(productImages)?.length === 0) {
      toast.error("Please select product images!");
      return;
    }

    const ParseEstimatedDecorTime = Object.fromEntries(
      Object.entries(dataForSendToApi.productDetails).map(
        ([key, value], index) => {
          if (key === "estimatedecorativetime") return [key, Number(value)];
          else return [key, value];
        }
      )
    );

    formData.append("productDetails", JSON.stringify(ParseEstimatedDecorTime));
    formData.append(
      "priceDetails",
      JSON.stringify(dataForSendToApi.priceDetails)
    );
    formData.append(
      "productdescription",
      JSON.stringify(dataForSendToApi.productdescription)
    );
    // formData.append(
    //   "description",
    //   dataForSendToApi.productcustomizeDetails.description
    // );
    formData.append(
      "availableCities",
      dataForSendToApi.availableCities.cityName
    );

    Object.entries(productImages).forEach(([key, file]) => {
      formData.append("productimages", file);
    });

    // Array.from(customImages).forEach((file) => {
    //   formData.append("customimages", file);
    // });

    formData.append("productcustomizeDetails", JSON.stringify(customObj));

    dispatch(EditProductSlice({ id, formData })).then((res) => {
      console.log(res.payload.data);
      if (Object.entries(res.payload.data ?? {})?.length > 0) {
        navigate(-1);
      }
    });
  };

  useEffect(() => {
    dispatch(GetCustomizeProductListSlice()).then((res) => {
      setCustomizeProduct(res?.payload?.data);
    });
  }, []);

  // useEffect(()=>{
  //   console.log("**:",customObj,CustomizeProduct);
  // },[customObj,CustomizeProduct]);

  return (
    <>
      <>
        <div className="WrapperArea">
          <div className="WrapperBox">
            <div className="Small-Wrapper">
              <div className="row">
                <div className="col-sm-12">
                  <div className="TitleBox">
                    <h2>Product Information</h2>
                  </div>
                  <div className="ItineraryArea">
                    <div className="row">
                      <div className="col-sm-6">
                        <div className="form-group">
                          <label>Product Category</label>
                          <select
                            className="form-control"
                            name="productcategory"
                            value={dataForSendToApi?.productDetails?.productcategory
                              .toLowerCase()
                              .trim()}
                            onChange={(e) => {
                              setSelectedForProduct((prev) => ({
                                ...prev,
                                [e.target.name]:
                                  e.target.options[e.target.selectedIndex]
                                    .dataset.key,
                              }));
                              handleChange(e, "productDetails");
                            }}
                          >
                            <option>--Select</option>
                            {Array.isArray(data?.categoryList) &&
                              data?.categoryList?.length &&
                              data.categoryList?.map((item, index) => {
                                // console.log(
                                //   "item?.categoryName",
                                //   item?.categoryName, dataForSendToApi?.productDetails?.productcategory,
                                //   item?.categoryName.toLowerCase().trim().length, dataForSendToApi?.productDetails?.productcategory.toLowerCase().trim().length
                                // );
                                return (
                                  <option
                                    value={item?.categoryName
                                      .toLowerCase()
                                      .trim()}
                                    data-key={item?._id}
                                  >
                                    {item?.categoryName}
                                  </option>
                                );
                              })}
                          </select>
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="form-group">
                          <label>Product Sub-Category</label>
                          <select
                            className="form-control"
                            name="productsubcategory"
                            value={
                              dataForSendToApi?.productDetails
                                ?.productsubcategory
                            }
                            onChange={(e) => {
                              handleChange(e, "productDetails");
                            }}
                          >
                            <option>--Select</option>
                            {Array.isArray(data?.subcategoryList) &&
                              data.subcategoryList?.length &&
                              data.subcategoryList?.map((item, index) => {
                                // console.log("item:",dataForSendToApi?.productDetails?.productsubcategory.split(''),item?.subcategoryName?.split(''))
                                return (
                                  <option value={item?.subcategoryName}>
                                    {item?.subcategoryName}
                                  </option>
                                );
                              })}
                          </select>
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="form-group">
                          <label>Title/Name of Product</label>
                          <input
                            type="text"
                            className="form-control"
                            name="productname"
                            value={
                              dataForSendToApi?.productDetails?.productname
                            }
                            onChange={(e) => {
                              handleChange(e, "productDetails");
                            }}
                          />
                        </div>
                        <div className="form-group">
                          <label>Estimate Decorator Time (Hours)</label>
                          <input
                            type="text"
                            className="form-control"
                            value={
                              dataForSendToApi?.productDetails
                                ?.estimatedecorativetime
                            }
                            name="estimatedecorativetime"
                            onChange={(e) => {
                              handleChange(e, "productDetails");
                            }}
                          />
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="form-group">
                          <label>City</label>
                          <ReactMultiSelectCheckboxes
                            options={AllCities}
                            value={SelectedOptions}
                            onChange={(e) =>
                              handleMultiSelectChange(e, "availableCities")
                            }
                          />
                        </div>
                        {/* <div className="form-group">
                          <label>Product Title Description</label>
                          <textarea
                            className="form-control"
                            placeholder="write here.."
                            rows={1}
                            defaultValue={""}
                            value={
                              dataForSendToApi?.productDetails
                                ?.producttitledescription
                            }
                            name="producttitledescription"
                            onChange={(e) => handleChange(e, "productDetails")}
                          />
                        </div> */}
                      </div>
                      <div className="col-sm-12">
                        <div className="form-group">
                          <label>Product Title Description</label>
                          {/* <textarea
                            className="form-control"
                            placeholder="write here.."
                            rows={1}
                            defaultValue={""}
                            name="producttitledescription"
                            onChange={(e) => handleChange(e, "productDetails")}
                          /> */}
                          <Editor
                            setContentState={setDataForSendToApi}
                            type={"DataTitleDesc"}
                            dataForSendToApi={dataForSendToApi}
                            content={
                              dataForSendToApi?.productDetails
                                ?.producttitledescription
                            }
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="Small-Wrapper">
              <div className="TitleBox">
                <h2>Price Details</h2>
              </div>
              <div className="ItineraryArea">
                <div className="row">
                  <div className="col-sm-4">
                    <div className="form-group">
                      <label>Actual Price</label>
                      <input
                        type="text"
                        className="form-control"
                        name="price"
                        value={dataForSendToApi?.priceDetails?.price}
                        onChange={(e) => handleChange(e, "priceDetails")}
                      />
                    </div>
                  </div>
                  <div className="col-sm-4">
                    <div className="form-group">
                      <label>Discounted Price</label>
                      <input
                        type="text"
                        className="form-control"
                        name="discountedPrice"
                        value={dataForSendToApi?.priceDetails?.discountedPrice}
                        onChange={(e) => handleChange(e, "priceDetails")}
                      />
                    </div>
                  </div>
                  <div className="col-sm-4">
                    <div className="form-group">
                      <label>GST Slab</label>
                      <select
                        className="form-control"
                        name="gstslab"
                        value={dataForSendToApi?.priceDetails?.gstslab}
                        onChange={(e) => handleChange(e, "priceDetails")}
                      >
                        <option selected="">--select--</option>
                        <option>18%</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="Small-Wrapper">
              <div className="TitleBox">
                <h2>Product Description</h2>
              </div>
              <div className="NewCommonTabs">
                <ul className="nav nav-tabs">
                  <li className="nav-item">
                    <a
                      className="nav-link active"
                      data-toggle="tab"
                      href="#Inclusion"
                    >
                      Inclusion
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className="nav-link"
                      data-toggle="tab"
                      href="#AboutTheExperience"
                    >
                      About The Experience
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className="nav-link"
                      data-toggle="tab"
                      href="#NeedToKnow"
                    >
                      Need To Know
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className="nav-link"
                      data-toggle="tab"
                      href="#CancellationPolicy"
                    >
                      Cancellation Policy
                    </a>
                  </li>
                </ul>
              </div>
              <div className="tab-content mb-4">
                <div className="tab-pane fade active show" id="Inclusion">
                  <aside className="file-info-checkbox">
                    <h4
                      style={{
                        fontSize: 16,
                        fontWeight: 600,
                        color: "#000",
                        margin: "10px 0 20px",
                      }}
                    >
                      Inclusion
                    </h4>
                    <Editor
                      setContentState={setDataForSendToApi}
                      type={"DataInclusion"}
                      dataForSendToApi={dataForSendToApi}
                      content={
                        dataForSendToApi?.productdescription?.inclusion?.[0]
                      }
                    />
                  </aside>
                </div>
                <div className="tab-pane fade" id="AboutTheExperience">
                  <div className="ItineraryArea">
                    <div className="form-group">
                      <label>About The Experience</label>

                      <Editor
                        setContentState={setDataForSendToApi}
                        type={"DataExperience"}
                        dataForSendToApi={dataForSendToApi}
                        content={
                          dataForSendToApi?.productdescription?.aboutexperience
                        }
                      />
                    </div>
                  </div>
                </div>
                <div className="tab-pane fade" id="NeedToKnow">
                  <div className="ItineraryArea">
                    <div className="row">
                      <div className="col-sm-12">
                        <div className="form-group">
                          <label>Need To Know</label>
                          <Editor
                            setContentState={setDataForSendToApi}
                            type={"DataNeedToKnow"}
                            dataForSendToApi={dataForSendToApi}
                            content={dataForSendToApi?.productdescription?.need}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="tab-pane fade" id="CancellationPolicy">
                  <div className="ItineraryArea">
                    <div className="row">
                      <div className="col-sm-12">
                        <div className="form-group">
                          <label>Cancellation Policy</label>
                          <Editor
                            setContentState={setDataForSendToApi}
                            type={"DataForCancellation"}
                            dataForSendToApi={dataForSendToApi}
                            content={
                              dataForSendToApi?.productdescription?.cancellation
                            }
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="Small-Wrapper">
              <div className="TitleBox">
                <h2>Product Images</h2>
              </div>
              <div className="row">
                <div className="col-sm-12">
                  <div className="ItineraryArea">
                    <div className="row">
                      <div className="col-sm-4">
                        <div className="form-group">
                          <label>Upload Images</label>
                          <div className="UploadBox">
                            <div className="Upload">
                              <i className="fa fa-upload" /> <span>Upload</span>
                              <input
                                type="file"
                                multiple
                                name="productImage"
                                onChange={handleImage}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="ProductImages ProfileBox2">
                          {Object.entries(productImages ?? {})?.map(
                            ([key, value], index) => {
                              // console.log("value:",value)
                              return (
                                <figure>
                                  <img
                                    src={value}
                                    style={{
                                      height: "150px",
                                      width: "300px",
                                      objectFit: "cover",
                                    }}
                                    key={key}
                                    alt=""
                                  />
                                  <i
                                    className="fa fa-times"
                                    aria-hidden="true"
                                    onClick={() => handleRemove(key)}
                                  />
                                </figure>
                              );
                            }
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="Small-Wrapper">
              <div className="TitleBox">
                <h2>Product Customization Details</h2>
              </div>
              <div className="row">
                <div className="col-sm-12">
                  <div className="ItineraryArea">
                    <div
                      className="row"
                      style={{ maxHeight: "800px", overflow: "scroll" }}
                    >
                      <div className="" style={{ paddingLeft: "20px" }}>
                        <>
                          {CustomizeProduct?.map((item, key) => {
                            return (
                              <div
                                style={{
                                  minWidth: "100%",
                                  display: "flex",
                                  flexDirection: "column",
                                  cursor: "pointer",
                                  gap: "10px",
                                  marginBottom: "20px",
                                  border: "1px solid lightgray",
                                  padding: "10px",
                                  borderRadius: "10px",
                                  position: "relative",
                                  backgroundColor: `${customObj.some(
                                    (temp, index) =>
                                      console.log(
                                        temp,
                                        item,
                                        temp?.customproductId == item?._id
                                      )
                                  )}`,
                                  backgroundColor: `${
                                    customObj.some(
                                      (temp, index) =>
                                        temp?.customproductId === item?._id
                                    )
                                      ? "#b93df4"
                                      : "white"
                                  }`,
                                  color: `${
                                    customObj.some(
                                      (temp, index) =>
                                        temp?.customproductId === item?._id
                                    )
                                      ? "white"
                                      : "black"
                                  }`,
                                }}
                                onClick={() =>
                                  setCustomeObj((prev) => {
                                    console.log(
                                      customObj.some(
                                        (data, index) =>
                                          data?.customproductId === item?._id
                                      )
                                    );
                                    if (
                                      customObj.some(
                                        (data, index) =>
                                          data?.customproductId === item?._id
                                      )
                                    ) {
                                      return customObj.filter(
                                        (dataItem, i) =>
                                          dataItem?.customproductId !==
                                          item?._id
                                      );
                                    }
                                    return [
                                      ...prev,
                                      {
                                        name: item.name,
                                        price: item?.price,
                                        customimages: item?.customimage,
                                        description: item?.description,
                                        customproductId: item?._id,
                                      },
                                    ];
                                  })
                                }
                              >
                                <div
                                  key={key}
                                  style={{
                                    display: "flex",
                                    gap: "10px",
                                    justifyContent: "space-around",
                                  }}
                                >
                                  <div>
                                    <p
                                      style={{
                                        textTransform: "capitalize",
                                        // color: "#000",
                                        fontSize: "14px",
                                        fontWeight: "700",
                                      }}
                                    >
                                      Product Name
                                    </p>
                                    <input
                                      type="text"
                                      class="form-control"
                                      disabled={true}
                                      value={item["name"]}
                                      name="name"
                                    />
                                  </div>
                                  <div>
                                    <p
                                      style={{
                                        textTransform: "capitalize",
                                        // color: "#000",
                                        fontSize: "14px",
                                        fontWeight: "700",
                                      }}
                                    >
                                      Product Price
                                    </p>
                                    <input
                                      type="text"
                                      class="form-control"
                                      disabled={true}
                                      value={item["price"]}
                                      name="ProductPrice"
                                    />
                                  </div>
                                  <div>
                                    <p
                                      style={{
                                        textTransform: "capitalize",
                                        // color: "#000",
                                        fontSize: "14px",
                                        fontWeight: "700",
                                      }}
                                    >
                                      Product description
                                    </p>
                                    <div>
                                      <div
                                        dangerouslySetInnerHTML={{
                                          __html: `${item?.description?.slice(
                                            0,
                                            20
                                          )}...`,
                                        }}
                                      />
                                      <div />
                                    </div>
                                  </div>
                                  <div>
                                    <p
                                      style={{
                                        textTransform: "capitalize",
                                        // color: "#000",
                                        fontSize: "14px",
                                        fontWeight: "700",
                                      }}
                                    >
                                      Product Image
                                    </p>
                                    <div
                                      style={{
                                        position: "relative",
                                        width: "100px",
                                        height: "60px",
                                        border: "2px dotted grey",
                                        backgroundColor: "#6e60601c",
                                      }}
                                    >
                                      <div>
                                        <img
                                          src={item["customimage"]}
                                          style={{
                                            height: "60px",
                                            width: "100px",
                                          }}
                                          alt="Loading from Bucket"
                                          srcset=""
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <button
              disabled={loading}
              onClick={handleSubmit}
              className="Button"
            >
              {loading ? <ButtonSpinner /> : "Update Product"}
            </button>
          </div>
        </div>
        <div className="ModalBox">
          <div id="EditPurchase" className="modal fade" role="dialog">
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-body">
                  <div className="Category">
                    <a
                      href="javascript:void(0);"
                      className="CloseModal"
                      data-dismiss="modal"
                    >
                      ×
                    </a>
                    <h3>Edit Details</h3>
                    <div className="form-group">
                      <label>Name</label>
                      <input type="text" className="form-control" />
                    </div>
                    <div className="form-group">
                      <label>Contact No.</label>
                      <input type="text" className="form-control" />
                    </div>
                    <div className="form-group">
                      <label>Address</label>
                      <input type="text" className="form-control" />
                    </div>
                    <button className="Button">Update details</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    </>
  );
};

export default ProductCatalogueEdit;
